import { Box, Button, Card, Grid } from "@mui/material";

import { useState } from "react";
import Flex from "../../../../../../components/Flex";
import StyledDialog from "../../../../../../components/StyledDialog";
import Text from "../../../../../../components/Text";
import { DisclosureHost } from "../../../../../../hooks/use-disclosure";
import csvColor from "/public/csv-color.svg";
import csvDisable from "/public/csv-disable.svg";
import patientColor from "/public/patient-color.svg";
import patientDisable from "/public/patient-detail-disable.svg";
// import stediDisable from "/public/claims/stedi-md-inactive.svg";
// import stediMdColor from "/public/claims/stedi-md-active.svg";

type CardValue = "paper_claim" | "electronic_claim" | "STEDI";

type Card = {
  value: CardValue;
  name: string;
  active: string;
  disable: string;
};

interface NavSubmitClaimModalProps {
  disclosureHost: DisclosureHost;
  onNextClick: (v: CardValue | null) => void;
}

const CARD_DATA: Card[] = [
  {
    name: "Paper Claim",
    value: "paper_claim",
    active: csvColor,
    disable: csvDisable,
  },
  {
    name: "Electronic Claim",
    value: "electronic_claim",
    active: patientColor,
    disable: patientDisable,
  },
  // {
  //   name: "Stedi",
  //   value: "STEDI",
  //   active: stediMdColor,
  //   disable: stediDisable,
  // },
];

const NavSubmitClaimModal = ({
  disclosureHost,
  onNextClick,
}: NavSubmitClaimModalProps) => {
  const [curActiveCard, setCurActiveCard] = useState<CardValue | null>(null);

  return (
    <StyledDialog
      open={disclosureHost.opened}
      dialogTitle={"Please select claim type for submission"}
      onClose={() => {
        disclosureHost.close();
        setCurActiveCard(null);
      }}
      dialogAction={
        <Flex gap={"20px"}>
          <Button
            sx={{ width: "6.25rem" }}
            onClick={() => onNextClick(curActiveCard)}
            variant="contained"
          >
            Save and Next
          </Button>
        </Flex>
      }
    >
      <Box width={"36.75rem"} mt={"5rem"} style={{ height: "307.5px" }}>
        <Grid container spacing={3} justifyContent={"space-evenly"}>
          {CARD_DATA?.map((it, idx) => (
            <Grid
              key={idx}
              style={{ cursor: "pointer" }}
              item
              xs={4}
              onClick={() => {
                setCurActiveCard(it.value);
              }}
              width="180px"
            >
              {it.value === curActiveCard ? (
                <img width="180px" height="180px" src={it.active} />
              ) : (
                <img width="180px" height="180px" src={it.disable} />
              )}
              <Text px={"2rem"} mt={"10px"} textAlign={"center"}>
                {it.name}
              </Text>
            </Grid>
          ))}
        </Grid>
      </Box>
    </StyledDialog>
  );
};

export default NavSubmitClaimModal;

interface ClaimSaveModalProps {
  disclosureHost: DisclosureHost;
  onSave: (v: CardValue | null) => void;
}

export const ClaimSaveModal = ({
  disclosureHost,
  onSave,
}: ClaimSaveModalProps) => {
  const [curActiveCard, setCurActiveCard] = useState<CardValue | null>(null);

  return (
    <StyledDialog
      open={disclosureHost.opened}
      dialogTitle={"Please select claim type for Save"}
      onClose={() => {
        disclosureHost.close();
        setCurActiveCard(null);
      }}
      dialogAction={
        <Flex gap={"20px"}>
          <Button
            sx={{ width: "6.25rem" }}
            onClick={() => onSave(curActiveCard)}
            variant="contained"
          >
            Save
          </Button>
        </Flex>
      }
    >
      <Box width={"36.75rem"} mt={"5rem"} style={{ height: "307.5px" }}>
        <Grid container spacing={3} justifyContent={"space-evenly"}>
          {CARD_DATA?.map((it) => (
            <Grid
              key={it?.value}
              style={{ cursor: "pointer" }}
              item
              xs={4}
              onClick={() => {
                setCurActiveCard(it.value);
              }}
              width="180px"
            >
              <img
                width="180px"
                height="180px"
                src={it.value === curActiveCard ? it["active"] : it["disable"]}
              />
              <Text px={"2rem"} mt={"10px"} textAlign={"center"}>
                {it.name}
              </Text>
            </Grid>
          ))}
        </Grid>
      </Box>
    </StyledDialog>
  );
};
